<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="backmatter-rw Copyright-rw" epub:type="backmatter copyright-page" id="Copyright2">
<div class="block-rw copyright-rw" id="copyright2">
<p class="crt-rw">This book is a work of fiction. Names, characters, places, and incidents are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.</p>
<p class="crt-rw">Copyright © 2015 by Marina Chappie<br/>Excerpt from the first book in the <em>Last Kiss of Summer</em> copyright © 2015 by Marina Chappie</p>
<p class="crt-rw">Cover design by Daniela Medina. Cover copyright © 2024 by Hachette Book Group, Inc.</p>
<p class="crt-rw">Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.</p>
<p class="crt-rw">The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.</p>
<p class="crt-rw">Forever<br/>Hachette Book Group<br/>1290 Avenue of the Americas, New York, NY 10104<br/><a href="http://read-forever.com" target="_blank">read-forever.com</a><br/>@readforeverpub</p>
<p class="crt-rw">Originally published as <em>A Taste of Sugar</em> in mass market and ebook in August 2015<br/>Reissued as <em>Reunion in Sugar Lake</em>: November 2024</p>
<p class="crt-rw">Forever is an imprint of Grand Central Publishing. The Forever name and logo are registered trademarks of Hachette Book Group, Inc.</p>
<p class="crt-rw">The publisher is not responsible for websites (or their content) that are not owned by the publisher.</p>
<p class="crt-rw">The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to hachettespeakersbureau.com or email HachetteSpeakers@hbgusa.com.</p>
<p class="crt-rw">Forever books may be purchased in bulk for business, educational, or promotional use. For information, please contact your local bookseller or the Hachette Book Group Special Markets Department at special.markets@hbgusa.com.</p>
<p class="crt-rw">ISBNs: 9781538767108 (mass market reissue), 9781455528691 (ebook)</p>
<p class="crt-rw">E3-20240904-PDJ-PC-REV</p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s033-Copyright-01.vue?3a0a47f1